import React from 'react';
import classNames from 'classnames';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Close } from '@material-ui/icons';
import { Icon } from '@modernhealth/vital-components';

import { colors } from '../../themes/colors';
import { BENEFIT_RESOURCE_TYPE } from '../../constants';

const styles = () => ({
  listItem: {
    borderBottom: `1px solid ${colors.gray12}`,
  },
  maxWidth: {
    maxWidth: 340,
  },
  useMargin: {
    margin: 5,
  },
  listItemSelected: {
    backgroundColor: colors.blue8,
  },
  nonClickableContainer: {
    position: 'relative',
  },
  listCardItem: {
    display: 'flex',
    padding: 16,
  },
  listItemTextContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  listItemContentWrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:hover': {
      '& $listItemIcon': {
        display: 'block',
      },
    },
  },
  listItemIcon: {
    display: 'none',
  },
  itemImage: {
    height: 44,
    width: 44,
    borderRadius: 3,
    marginRight: 16,
  },
  itemName: {
    fontFamily: 'Avenir-Heavy',
    fontSize: 14,
    color: colors.blue2,
  },
  itemType: {
    fontFamily: 'Avenir-Book',
    fontSize: 14,
    color: colors.gray5,
  },
  closeButton: {
    position: 'absolute',
    top: 5,
    right: 5,
    cursor: 'pointer',
  },
  recommendedIcon: {
    position: 'absolute',
    left: '32px',
    top: '32px',
    width: '20px',
    height: '20px',
  },
  benefitIcon: {
    position: 'relative',
    marginRight: '16px',
    width: '44px',
    height: '44px',
  },
});

const ChatResourceItem = ({
  classes,
  item,
  useMargin,
  removeResource,
  noClick,
  maxWidth,
  toggleResource = () => {},
  fromDrawer = false,
  toggleShowResourceInfoPanel = () => {},
  setSelectedItem = () => {},
}) => {
  const isBenefit = item.resourceType === BENEFIT_RESOURCE_TYPE;

  const content = (
    <CardContent
      className={classes.listCardItem}
      onClick={() => {
        if (!isBenefit) {
          toggleResource(item);
        } else {
          toggleShowResourceInfoPanel();
          setSelectedItem(item);
        }
      }}
    >
      {removeResource && (
        <Close
          className={classes.closeButton}
          onClick={() => {
            removeResource(item);
          }}
        />
      )}
      <div className={classes.benefitIcon}>
        <img
          style={
            !isBenefit
              ? null
              : {
                  backgroundColor: item.color,
                  padding: '8px',
                  position: 'absolute',
                }
          }
          className={classes.itemImage}
          src={item.image}
          alt="resource-item"
        />
        {item.topicsInCommon > 0 && fromDrawer && (
          <img
            className={classes.recommendedIcon}
            src={require('../../assets/images/star.svg').default}
            alt="recommended"
          />
        )}
      </div>

      <div className={classes.listItemContentWrapper}>
        <div className={classes.listItemTextContainer}>
          <Typography className={classes.itemName}>{item.name}</Typography>
          <Typography className={classes.itemType}>
            {isBenefit ? 'Benefit' : item.resourceType}
          </Typography>
        </div>

        {isBenefit && fromDrawer && (
          <div className={classes.listItemIcon}>
            <Icon name="chevron-right" size={20} color="gray65" />
          </div>
        )}
      </div>
    </CardContent>
  );

  return (
    <Card
      key={item.id}
      className={classNames(classes.listItem, {
        [classes.listItemSelected]: item.isSelected,
        [classes.useMargin]: useMargin,
        [classes.maxWidth]: maxWidth,
      })}
    >
      {noClick ? (
        <div className={classes.nonClickableContainer}>{content}</div>
      ) : (
        <CardActionArea>{content}</CardActionArea>
      )}
    </Card>
  );
};

export default withStyles(styles)(ChatResourceItem);
